import { merge } from 'lodash'
import * as components from './components'
import { customPalette } from './palette'

export const customTheme = merge(
  { components },
  { palette: customPalette },
  { mode: 'light' },
)
